module.exports = __webpack_public_path__ + "static/media/ql-icon-happyhour.b00179da.svg";